package br.com.texeratx.boardgametimeapp.core.di

import br.com.texeratx.boardgametimeapp.data.repository.ClanRepository
import br.com.texeratx.boardgametimeapp.data.repository.UploadRepository
import br.com.texeratx.boardgametimeapp.domain.usecases.upload.UploadClanImageUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.upload.UploadUserImageUseCase
import br.com.texeratx.boardgametimeapp.ui.screens.clan.ClanViewModel
import br.com.texeratx.boardgametimeapp.ui.screens.myclans.ClanMembersViewModel
import br.com.texeratx.boardgametimeapp.ui.screens.myclans.EditProfileViewModel
import br.com.texeratx.boardgametimeapp.ui.screens.myclans.MyClansViewModel
import org.koin.dsl.module

val clanModule = module {

    single { ClanRepository(get(), get()) }
    factory { UploadRepository(get(), get()) }
    factory { UploadClanImageUseCase(get()) }
    factory { UploadUserImageUseCase(get()) }
    factory { ClanViewModel(get(), get(), get(), get()) }
    factory { MyClansViewModel(get(), get()) }
    factory { (clanId: Long) -> ClanMembersViewModel(get(), get(), clanId) }
    factory { EditProfileViewModel(get(), get(), get()) }
}
